
import { defineComponent } from "vue";
import GeneralFilterableIndex from "./containers/GeneralFilterableIndex.vue";
export default defineComponent({
  components: {
    GeneralFilterableIndex
  },
  props: {
    showkeywords: {
      type: Boolean,
      required: true,
      default: true
    },
    filtergroupids: {
      type: String,
      required: true,
      default: ""
    },
    filteryear: {
      type: Boolean,
      required: true,
      default: true
    },
    parentid: {
      type: Number,
      required: true,
      default: -1
    },
    pagesize: {
      type: Number,
      required: true,
      default: 20
    },
    title: {
      type: String,
      required: true,
      default: ""
    },
    resultType: {
      type: String,
      required: true,
      default: ""
    },
    baseUri: {
      type: String,
      required: true,
      default: ""
    },
    language: {
      type: String,
      required: false,
      default: ""
    },
    personalisationGroupIds: {
      type: String,
      required: false,
      default: ""
    }
  }
});
